import '@babel/polyfill'
import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router/index'
import store from './store/index'
import './registerServiceWorker'

// axios interceptors
require('./utilities/interceptors')

// register custom directives
require('./utilities/customDirectives')

// register global components
require('./utilities/globalComponentLoader')

// register custom vue propeties
require('./utilities/customGlobalProperties')

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
